import type { NextResponse } from 'next/server';

export const IDP_ACCESS_TOKEN_COOKIE = '__Secure-klew-access-token';

export const IDP_ACCESS_TOKEN_EXPIRES_COOKIE = 'klew-access-token-expires';

const DEFAULT_ACCESS_TOKEN_MAX_AGE_SEC = 3600;

type CookieWritableResponse = Pick<NextResponse, 'cookies'>;

export function writeIdpAccessTokenCookie(
  response: CookieWritableResponse,
  {
    accessToken,
    expiresAt,
    useSecure,
    current,
    currentExpires,
  }: {
    accessToken?: string;
    expiresAt?: number;
    useSecure: boolean;
    current?: string;
    currentExpires?: string;
  },
): void {
  const domainOption = process.env.IDP_COOKIE_DOMAIN
    ? { domain: process.env.IDP_COOKIE_DOMAIN }
    : {};

  const sharedOptions = {
    secure: useSecure,
    sameSite: 'lax' as const,
    path: '/',
    ...domainOption,
  };

  if (accessToken) {
    const maxAge = expiresAt
      ? Math.max(0, expiresAt - Math.floor(Date.now() / 1000))
      : DEFAULT_ACCESS_TOKEN_MAX_AGE_SEC;
    // 期限(expiresAt)が変われば access_token Cookie の maxAge も更新が必要。
    const expiresChanged = String(expiresAt ?? '') !== (currentExpires ?? '');

    // access_token 本体は、値が変わったとき、または期限が変わって maxAge を揃えるべきときに焼く。
    // (両 Cookie の失効時刻がズレて gate が旧失効を見逃すのを防ぐ)
    if (accessToken !== current || expiresChanged) {
      response.cookies.set(IDP_ACCESS_TOKEN_COOKIE, accessToken, {
        httpOnly: true,
        ...sharedOptions,
        maxAge,
      });
    }

    // 鮮度 Cookie は expiresAt があれば同期、無ければ残存を削除する(古い期限の seed を防ぐ)。
    if (expiresAt) {
      if (String(expiresAt) !== currentExpires) {
        response.cookies.set(IDP_ACCESS_TOKEN_EXPIRES_COOKIE, String(expiresAt), {
          httpOnly: false,
          ...sharedOptions,
          maxAge,
        });
      }
    } else if (currentExpires) {
      response.cookies.set(IDP_ACCESS_TOKEN_EXPIRES_COOKIE, '', {
        httpOnly: false,
        ...sharedOptions,
        maxAge: 0,
      });
    }
  } else if (current || currentExpires) {
    response.cookies.set(IDP_ACCESS_TOKEN_COOKIE, '', {
      httpOnly: true,
      ...sharedOptions,
      maxAge: 0,
    });
    response.cookies.set(IDP_ACCESS_TOKEN_EXPIRES_COOKIE, '', {
      httpOnly: false,
      ...sharedOptions,
      maxAge: 0,
    });
  }
}
